import { forwardRef, useMemo } from "react";
import { BsShieldLock } from "react-icons/bs";
import AppLauncherTile from "./AppLauncherTile";
import { LauncherApp } from "./types";

interface AppLauncherPanelProps {
  apps: LauncherApp[];
  titleId: string;
  /** Called when a tile is selected so the launcher can close. */
  onSelect: () => void;
}

const AppLauncherPanel = forwardRef<HTMLDivElement, AppLauncherPanelProps>(
  ({ apps, titleId, onSelect }, ref) => {
    // Sort by label, locale-aware and case-insensitive.
    const sorted = useMemo(
      () => [...apps].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" })),
      [apps],
    );

    return (
      <div className="app-launcher-panel" role="dialog" aria-labelledby={titleId} ref={ref}>
        <h2 className="app-launcher-panel-title" id={titleId}>
          Apps
        </h2>

        {sorted.length === 0 ? (
          <div className="app-launcher-empty">
            <BsShieldLock className="app-launcher-empty-icon" aria-hidden="true" />
            <p className="app-launcher-empty-title">No other apps available</p>
            <p className="app-launcher-empty-message">
              You don't have access to any other applications. Contact your supervisor to request access.
            </p>
          </div>
        ) : (
          <div className="app-launcher-grid">
            {sorted.map((app) => (
              <AppLauncherTile key={app.url} app={app} onSelect={onSelect} />
            ))}
          </div>
        )}
      </div>
    );
  },
);

AppLauncherPanel.displayName = "AppLauncherPanel";

export default AppLauncherPanel;
